export const oneAppResidents = [
  {
    name: 'Home',
    url: '/one-app/residents',
    icon: 'fa fa-cube'
  },
  {
    name: 'Add Resident',
    url: '/one-app/residents/new',
    icon: 'icon-plus'
  }
];
